/**
 * `prefers-reduced-motion`, watched rather than sampled.
 *
 * Read once at startup it would be a snapshot, and the setting is one people reach for
 * *because* something on screen is making them unwell — so it has to take effect in the
 * session where it was changed, not the next one.
 */
import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

function query(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(QUERY);
}

export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => query()?.matches ?? false);

  useEffect(() => {
    const mq = query();
    if (!mq) return;
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    mq.addEventListener('change', onChange);
    // Re-read on mount: the initial state was computed during the first render, and a
    // change between that render and this effect would otherwise be missed permanently.
    setReduced(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
